import { call, put, takeLatest } from 'redux-saga/effects';
import {
  changeExpensePrice,
  createExpense,
  createExpenseComment,
  deleteExpense,
  getExpenseDetail,
  getExpenseList,
  getMyExpenseList,
  updateExpense,
} from '../../api/constlink';
import {
  deleteExpenseAsync,
  DELETE_EXPENSE,
  getExpenseDetailAsync,
  getExpenseListAsync,
  GET_EXPENSE_DETAIL,
  GET_EXPENSE_LIST,
  updateExpenseAsync,
  UPDATE_EXPENSE,
  createExpenseAsync,
  CREATE_EXPENSE,
  createExpenseCommentAsync,
  CREATE_EXPENSE_COMMENT,
  getMyExpenseListAsync,
  GET_MY_EXPENSE_LIST,
  changeExpensePriceAsync,
  CHANGE_EXPENSE_PRICE,
} from './actions';
import { Expense } from './types';

function* getExpenseListSaga(
  action: ReturnType<typeof getExpenseListAsync.request>,
) {
  try {
    const expenses: Expense[] = yield call(getExpenseList, action.payload);
    yield put(getExpenseListAsync.success(expenses));
  } catch (e: any) {
    yield put(getExpenseListAsync.failure(e));
  }
}

function* getMyExpenseListSaga(
  action: ReturnType<typeof getMyExpenseListAsync.request>,
) {
  try {
    const expenses: Expense[] = yield call(getMyExpenseList, action.payload);
    yield put(getMyExpenseListAsync.success(expenses));
  } catch (e: any) {
    yield put(getMyExpenseListAsync.failure(e));
  }
}

function* updateExpenseSaga(
  action: ReturnType<typeof updateExpenseAsync.request>,
) {
  try {
    const expense: Expense = yield call(updateExpense, action.payload);
    yield put(updateExpenseAsync.success(expense));
  } catch (e: any) {
    yield put(updateExpenseAsync.failure(e));
  }
}

function* deleteExpenseSaga(
  action: ReturnType<typeof deleteExpenseAsync.request>,
) {
  try {
    const expenseId: number = yield call(deleteExpense, action.payload);
    yield put(deleteExpenseAsync.success(expenseId));
  } catch (e: any) {
    yield put(deleteExpenseAsync.failure(e));
  }
}

function* getExpenseDetailSaga(
  action: ReturnType<typeof getExpenseDetailAsync.request>,
) {
  try {
    const expense: Expense = yield call(getExpenseDetail, action.payload);
    yield put(getExpenseDetailAsync.success(expense));
  } catch (e: any) {
    yield put(getExpenseDetailAsync.failure(e));
  }
}

function* createExpenseSaga(
  action: ReturnType<typeof createExpenseAsync.request>,
) {
  try {
    const expense: Expense = yield call(createExpense, action.payload);
    yield put(createExpenseAsync.success(expense));
  } catch (e: any) {
    yield put(createExpenseAsync.failure(e));
  }
}

function* createExpenseCommentSaga(
  action: ReturnType<typeof createExpenseCommentAsync.request>,
) {
  try {
    const expense: Expense = yield call(createExpenseComment, action.payload);
    yield put(createExpenseCommentAsync.success(expense));
  } catch (e: any) {
    yield put(createExpenseCommentAsync.failure(e));
  }
}

function* changeInoicePriceSaga(
  action: ReturnType<typeof changeExpensePriceAsync.request>,
) {
  try {
    const expense: Expense = yield call(changeExpensePrice, action.payload);
    yield put(changeExpensePriceAsync.success(expense));
  } catch (e: any) {
    yield put(changeExpensePriceAsync.failure(e));
  }
}

export function* expensesSaga() {
  yield takeLatest(GET_EXPENSE_LIST, getExpenseListSaga);
  yield takeLatest(GET_MY_EXPENSE_LIST, getMyExpenseListSaga);
  yield takeLatest(UPDATE_EXPENSE, updateExpenseSaga);
  yield takeLatest(DELETE_EXPENSE, deleteExpenseSaga);
  yield takeLatest(GET_EXPENSE_DETAIL, getExpenseDetailSaga);
  yield takeLatest(CREATE_EXPENSE, createExpenseSaga);
  yield takeLatest(CREATE_EXPENSE_COMMENT, createExpenseCommentSaga);
  yield takeLatest(CHANGE_EXPENSE_PRICE, changeInoicePriceSaga);
}
